import { render, staticRenderFns } from "./ticket.vue?vue&type=template&id=18da50da&scoped=true&"
import script from "./ticket.vue?vue&type=script&lang=ts&"
export * from "./ticket.vue?vue&type=script&lang=ts&"
import style0 from "./ticket.vue?vue&type=style&index=0&id=18da50da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18da50da",
  null
  
)

export default component.exports